import { LibraryState, LibraryTypes } from './types';
import { LibraryActions } from './actions';
import { combineReducers } from '@fullstory/redux-util/utils';

const query = (
  state: LibraryState = { filter: 'active', search: '' },
  action: LibraryActions,
): LibraryState => {
  switch (action.type) {
    case LibraryTypes.SetLibraryObjectLandingQuery:
      return action.query;
  }
  return state;
};

type LibraryReducerState = {
  query: ReturnType<typeof query>;
};

export const libraryReducer = combineReducers<LibraryReducerState>({
  query,
});
